import { useEffect, useRef, useState } from 'react';

const ONE_SECOND_MS = 1000;

export const useSmsCountdown = (localStorageKey: string) => {
  const [millisecondsLeft, setMillisecondsLeft] = useState(() => {
    const expiry = Number(localStorage.getItem(localStorageKey) || 0);
    return Math.max(0, expiry - Date.now());
  });

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (millisecondsLeft <= 0) {
      return;
    }

    intervalRef.current = setInterval(() => {
      setMillisecondsLeft((prev) => {
        const next = prev - ONE_SECOND_MS;
        if (next <= 0) {
          clearInterval(intervalRef.current!);
          localStorage.removeItem(localStorageKey);
          return 0;
        }
        return next;
      });
    }, ONE_SECOND_MS);

    return () => clearInterval(intervalRef.current!);
  }, [millisecondsLeft, localStorageKey]);

  const setCountdown = (retryAfterMs: number) => {
    const expiry = Date.now() + retryAfterMs;
    localStorage.setItem(localStorageKey, String(expiry));
    setMillisecondsLeft(retryAfterMs);
  };

  return { millisecondsLeft, setCountdown };
};
